<template>
  <img style="width: 100%" src="https://www.jumpdesign.co.uk/wp-content/uploads/2021/02/BANNER-LOGO.jpg"/>
</template>

<script>
export default {
  name: "fixtureSlider"
}
</script>

<style scoped>
img {
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/sportsbook/widget/fixtureSlider.vue